// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification_notification__2lEK8","pending":"notification_pending__13nR4","success":"notification_success__2LYeu","error":"notification_error__1Dac6"};